// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d6dcc7d1","389":"bfe71b2e","453":"3520fba9","455":"93d1811e","970":"00b20f82","977":"caff0f3d"}[chunkId] + ".chunk.js";
};